module.exports = __webpack_public_path__ + "static/media/logo.461e515c.svg";